export default __webpack_public_path__ + "static/media/dreamstime_xs_85936032.79bf124c.jpg";